import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60 * 4, // 4 hours
      refetchOnWindowFocus: false,
    },
  },
});

export default queryClient;
